import Admin from "src/pages/admin/admin";
import { AdminRoute } from "src/appConfig/AdminRoute";
import { AppRoutes } from "../common/constants/constantEnums";
import { ComingSoon } from "src/pages/home/pages/comingSoon";
import { ForgotPassword } from "src/pages/forgotPassword";
import { Home } from "src/pages/homePage";
import LandingPage from "src/pages/home/landingPage";
import { LegalDocuments } from "src/pages/legalDocuments";
import { LoginPage } from "src/pages/loginPage";
import { Matrimony } from "src/pages/matrimony/pages/matrimony";
import MatrimonyContactRequest from "src/pages/matrimony/pages/matrimonyContactRequest";
import MatrimonyForm from "src/pages/matrimony/pages/matrimonyForm";
import MatrimonyLayout from "src/pages/matrimony/matrimonyLayout";
import MatrimonyProfileDetailsPage from "src/pages/matrimony/pages/matrimonyProfileDetails";
import MatrimonySearchResultsPage from "src/pages/matrimony/pages/matrimonySearchResults";
import { PrivacyPolicy } from "../pages/home/pages/privacyPolicy";
import { Profile } from "src/pages/profile/profile";
import { ProtectedRoute } from "src/appConfig/protectedRoute";
import { PublicRoute } from "src/appConfig/PublicRoute";
import { RegisterPage } from "src/pages/register";
import RegistrationForm from "src/pages/register/registrationForm/registrationForm";
import { RegistrationGuide } from "src/pages/registrationGuide";
import SubmitPage from "src/pages/submit/submitPage";
import UserProfileDetails from "src/pages/admin/dashboard/UserProfileDetails";
import { createBrowserRouter } from "react-router-dom";

export const router = createBrowserRouter([
  {
    children: [
      {
        element: <LandingPage />,
        path: "/",
        index: true,
      },
      {
        element: <ComingSoon />,
        path: AppRoutes.COMING_SOON,
      },
      {
        element: <ForgotPassword />,
        path: AppRoutes.FORGOT_PASSWORD,
      },
      {
        element: <PublicRoute element={<LoginPage />} />,
        path: AppRoutes.LOGIN,
      },
      {
        element: <PublicRoute element={<RegisterPage />} />,
        path: AppRoutes.REGISTER,
      },
      {
        element: <ProtectedRoute element={<RegistrationForm />} />,
        path: AppRoutes.REGISTRATION_FORM,
      },
      {
        element: <ProtectedRoute element={<Profile />} />,
        path: AppRoutes.PROFILE,
      },
      {
        element: <AdminRoute element={<Admin />} />,
        path: AppRoutes.ADMIN,
      },
      {
        element: <ProtectedRoute element={<UserProfileDetails />} />,
        path: "/admin/user/:email",
      },
      {
        element: <ProtectedRoute element={<SubmitPage />} />,
        path: AppRoutes.SUBMIT,
      },
      {
        path: AppRoutes.MATRIMONY,
        element: (
          <ProtectedRoute element={<MatrimonyLayout />} />
        ),
        children: [
          {
            index: true,
            element: <Matrimony />,
          },
          {
            path: AppRoutes.MATRIMONY_PROFILE_DETAILS,
            element: <MatrimonyProfileDetailsPage />,
          },
          {
            path: AppRoutes.MATRIMONY_CONTACT_REQUEST,
            element: <MatrimonyContactRequest />,
          },
        ],
      },
      {
        element:<ProtectedRoute element={<MatrimonySearchResultsPage />} />,
        path: AppRoutes.MATRIMONY_SEARCH_RESULTS,
      },
      {
        element: (
          <MatrimonyForm
            isOpen={true}
            onClose={function (): void {
              // When rendered as a route page (not a modal), there is nothing to close.
              // Consumers can navigate away after submission.
            }}
          />
        ),
        path: AppRoutes.MATRIMONY_FORM,
      },
      {
        element: <Home />,
        path: AppRoutes.JOIN_US,
      },
      {
        element: <PrivacyPolicy />,
        path: AppRoutes.PRIVACY,
      },
      // {
      //   element: <DonationPage />,
      //   path: AppRoutes.DONATION_PAGE,
      // },
      {
        element: <LegalDocuments />,
        path: AppRoutes.LEGAL,
      },
      {
        element: <RegistrationGuide />,
        path: AppRoutes.REGISTRATION_GUIDELINES,
      }
      // {
      //   element: <AllEvents />,
      //   path: AppRoutes.ALL_EVENTS,
      // },
      // {
      //   element: <EventDetails />,
      //   path: AppRoutes.EVENT_DETAILS,
      // },
    ],
  },
]);
